import { BlogSection } from '@/types/blog';

export const biologischesFundament: BlogSection = {
  id: 'biologisches-fundament',
  title: 'Das biologische Fundament: Führung als lebendiges System',
  content: `
<p class="mb-4">
  Die Parallele zur Natur ist keine Metapher, sondern wissenschaftlich fundiert. Schauen wir in einen Wald: Unter der Erde verbindet ein gigantisches Myzel-Netzwerk die Wurzeln, tauscht Nährstoffe und Informationen aus. Kein Baum existiert für sich allein. Der Wald funktioniert als Organismus – resilient, anpassungsfähig, intelligent.
</p>

<p class="mb-4">
  Der Biologe Edward O. Wilson nannte diese Verbindung zur Natur die <strong>Biophilie-Hypothese</strong> (Wilson, 1984): die angeborene Tendenz, Beziehungen zu lebenden Systemen zu suchen. Das ist keine Esoterik, sondern Evolutionsbiologie. Wird diese Verbindung gekappt, zeigen Studien messbare Anstiege von Stress und psychischen Belastungen (Maas et al., 2009). Richard Louv prägte dafür den Begriff "Natur-Defizit-Syndrom" – die Entkopplung von unserer biologischen Grundausstattung.
</p>

<p class="mb-4">
  Genau diese Entkopplung erleben Organisationen, die in Silos denken: isolierte Abteilungen, lineare Karrierepfade, Spezialisierung als Dogma. Sie vergessen, dass komplexe Systeme durch Beziehung funktionieren, nicht durch Isolation.
</p>

<h3 class="text-xl font-semibold mt-8 mb-4">Attention Restoration Theory in der Praxis</h3>

<p class="mb-4">
  Die Attention Restoration Theory (ART) erklärt, warum natürliche Umgebungen unsere Konzentration wiederherstellen: Sie fesseln unsere Aufmerksamkeit mühelos, ohne sie zu erschöpfen (Kaplan, 1995). Katalysator-Führung wendet dieses Prinzip auf Organisationen an: Sie schafft "restaurative" Räume für kreatives Denken, frei von ständigem KPI-Druck.
</p>

<p class="mb-4">
  Studien bestätigen: Schon kurze Aufenthalte in der Natur senken Cortisol und steigern kognitive Leistungsfähigkeit (Song et al., 2016). Die praktische Konsequenz: Strategische Entscheidungen profitieren von kurzen Naturpausen. Ein 15-minütiger Spaziergang vor wichtigen Meetings ist keine verlorene Zeit, sondern eine Investition in bessere Urteilskraft.
</p>
  `,
};
